import { render, staticRenderFns } from "./TotalPaymentsOrderHistory.vue?vue&type=template&id=2b67c404&scoped=true&"
import script from "./TotalPaymentsOrderHistory.vue?vue&type=script&lang=js&"
export * from "./TotalPaymentsOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67c404",
  null
  
)

export default component.exports